<template>
  <b-form-group
    v-if="isEnabled(metaBlock, 'title')"
    :label="makeLabel(metaBlock, 'title', required)"
    :label-for="makeId('title')"
    :state="state.title"
    :invalid-feedback="invalid.title"
    :description="makeDesc(metaBlock, 'title')"
  >
    <b-form-select
      :id="makeId('title')"
      v-model="data.title"
      autocomplete="nope"
      :name="makeName('title')"
      :options="
        makeSelectOptions(metaBlock, 'title', [data.title, ...(extraOptions || [])])
      "
      :state="state.title"
      :disabled="disabled"
    />
  </b-form-group>
</template>

<script>
import FormFieldsMixin from "@/mixins/FormFieldsMixin";

export default {
  name: "TitleSelect",
  mixins: [FormFieldsMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    state: {
      type: Object,
      required: true,
    },
    invalid: {
      type: Object,
      required: true,
    },
    metaBlock: {
      type: String,
      required: true,
    },
    prefix: String,
    disabled: Boolean,
    required: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    extraOptions: Array,
  },
};
</script>
